import {useMemo} from "react";
import {useSelector} from "react-redux";
import {getEffectivePermissions, resolveActiveWorkspaceUserRoles} from "./workspace-permissions";

export default function Can({permission, children, scopeId, scopeRolePermissions, fallback = null}) {
    const {workspaceMembershipData} = useSelector((state) => state.app);
    const graphMembership = useSelector((state) => state.workspaceGraph.workspaceMembership);
    const graphUserRoles = useSelector((state) => state.workspaceGraph.userRoles);
    const permissions = useMemo(
        () => {
            const userRoles = resolveActiveWorkspaceUserRoles(
                workspaceMembershipData,
                graphMembership,
                graphUserRoles,
            );
            return getEffectivePermissions(
                userRoles,
                scopeId,
                scopeRolePermissions,
                workspaceMembershipData?.workspace?.workspaceStatus || "active",
            );
        },
        [
            graphUserRoles,
            graphMembership,
            scopeId,
            scopeRolePermissions,
            workspaceMembershipData,
        ],
    );

    if (!permission || permissions.includes("*") || permissions.includes(permission)) {
        return children;
    }

    return fallback;
}
